import script from "./DrawerPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./DrawerPanel.vue?vue&type=script&setup=true&lang=ts"

import "./DrawerPanel.vue?vue&type=style&index=0&id=369baa01&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369baa01"]])

export default __exports__